var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection2IconProblem = function SvgSection2IconProblem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.289,
    fill: "#FFF6F6",
    stroke: "#FF6A10",
    strokeWidth: 1.422
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.99 14.39 3.995-3.995 1.599 1.6-3.996 3.995 3.996 3.995-1.599 1.599-3.995-3.996-3.996 3.995-1.598-1.598 3.995-3.995-3.995-3.996 1.598-1.598 3.996 3.995Z",
    fill: "#FF6A10"
  })));
};
export default SvgSection2IconProblem;